<template>
    <h1>Patient home</h1>
    </template>
